const enableElement = element => {
  element.disabled = false;
};
const disableElement = element => {
  element.disabled = true;
};
export { enableElement, disableElement };